export default __webpack_public_path__ + "static/media/image-ph-health-statistics-m@2x.17bb0fe8.webp";